module.exports = __webpack_public_path__ + "media/images/icon_review-9d857c5361c4778fcec9dfda6941a1b7.svg";